import { useEffect } from "react";
import { Helmet } from "react-helmet-async";

const SITE = "https://comprenahg.com.br";

// Remove as tags de baseline do index.html (marcadas com data-static-seo) quando esta
// página define as suas próprias — evita canonical/descrição/og duplicados.
const removeStatic = (selector) => {
  document.querySelectorAll(`${selector}[data-static-seo]`).forEach((el) => el.remove());
};

export const Seo = ({ title, description, noindex = false, canonical, ogImage, jsonLd }) => {
  useEffect(() => {
    if (description) {
      removeStatic('meta[name="description"]');
      removeStatic('meta[property="og:description"]');
      removeStatic('meta[name="twitter:description"]');
    }
    if (title) {
      removeStatic('meta[property="og:title"]');
      removeStatic('meta[name="twitter:title"]');
    }
    if (ogImage) {
      removeStatic('meta[property="og:image"]');
      removeStatic('meta[name="twitter:image"]');
    }
    if (canonical && !noindex) {
      removeStatic('link[rel="canonical"]');
      removeStatic('meta[property="og:url"]');
    }
  }, [title, description, canonical, ogImage, noindex]);

  return (
    <Helmet>
      <title>{title}</title>
      {description && <meta name="description" content={description} />}
      {description && <meta name="twitter:description" content={description} />}
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      {!noindex && canonical && <link rel="canonical" href={`${SITE}${canonical}`} />}
      <meta property="og:title" content={title} />
      <meta name="twitter:title" content={title} />
      {description && <meta property="og:description" content={description} />}
      {!noindex && canonical && <meta property="og:url" content={`${SITE}${canonical}`} />}
      {ogImage && <meta property="og:image" content={ogImage.startsWith("http") ? ogImage : `${SITE}${ogImage}`} />}
      {ogImage && <meta name="twitter:image" content={ogImage.startsWith("http") ? ogImage : `${SITE}${ogImage}`} />}
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
};
